@import '../../new-lineup-plan-grid-shared-styles.module.less';

.select-plan-button {
  grid-area: @select-plan-button-grid-area;
}

.selected-label {
  grid-area: @select-plan-button-grid-area;
  color: var(--blue-600);
  margin: auto;
  text-align: center;
}
